import { Column, Index, JoinColumn, ManyToOne } from 'typeorm';
import { Entity } from '../../decorators';
import { BaseEntity } from './base.entity';
import { ObjectEntity } from './object.entity';
import { TriggerEntity } from './trigger.entity';

@Index('_fk__object__id', ['fkObjectId', 'modified', 'resourceId'], {})
@Index('_fk__trigger__id', ['fkTriggerId'], {})
@Entity('_audit', {}, { auditable: false })
export class AuditEntity extends BaseEntity {
	@Column('int', { name: '_fk__object__id', nullable: true, unsigned: true })
	public fkObjectId!: number | null;

	@Column('int', { name: '_fk__trigger__id', nullable: true, unsigned: true })
	public fkTriggerId!: number | null;

	@Column('text', { name: '_json', nullable: true })
	public json!: string | null;

	@Column('varchar', { name: '_method', nullable: true, length: 64 })
	public method!: string | null;

	@Column('datetime', { name: '_modified', nullable: true })
	public modified!: Date | null;

	@Column('int', { name: '_resourceId', nullable: true, unsigned: true })
	public resourceId!: number | null;

	@Column('int', { name: '_userId', nullable: true, unsigned: true })
	public userId!: number | null;

	@Column('text', { name: '_previousValues', nullable: true })
	public previousValues!: string | null;

	@Column('text', { name: '_path', nullable: true })
	public path!: string | null;

	@Column('text', { name: '_params', nullable: true })
	public params!: string | null;

	@Column('text', { name: '_body', nullable: true })
	public body!: string | null;

	@Column('int', { name: '_time', nullable: true, unsigned: true })
	public time!: number | null;

	@Column('int', { name: '_fk__request__id', nullable: true, unsigned: true })
	public fkRequestId!: number | null;

	@ManyToOne(() => ObjectEntity, (object) => object.audits, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;

	@ManyToOne(() => TriggerEntity, (trigger) => trigger.audits, {
		onDelete: 'RESTRICT',
		onUpdate: 'RESTRICT',
	})
	@JoinColumn([{ name: '_fk__trigger__id', referencedColumnName: 'id' }])
	public fkTrigger!: TriggerEntity;
}
